import { EntityType } from '@/types/entities/entityType';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import { EdsFilterEntities } from '@/features/eds/enums/EdsFilterEntities';
import { AddressHoldersEnum } from '@/enums/AddressHoldersEnum';

export function getFilterPropertyName({ entityType, entity }: { entityType: EntityType; entity?: string }): string {
  // first 2 conditions are for producer addresses history, keep the order as is, because producer.entityType is incorrect
  if (entity === AddressHoldersEnum.Producer) {
    return 'ProducerId';
  }
  if (entity === AddressHoldersEnum.ProducerGroup) {
    return 'ProducerGroupId';
  }
  if (entityType === EdsEntityCodes.Person) {
    return EdsFilterEntities.PersonId;
  }
  if (entityType === EdsEntityCodes.Business) {
    return EdsFilterEntities.BusinessId;
  }
  return '';
}
